import axios from 'axios'
import qs from 'qs'
import { baseApi } from '@/config'
import store from '@/store'
import { message } from 'ant-design-vue'
import Vue from 'vue'
import i18n from '@/i18n/langs'

Vue.clearArray = []
// 取消請求標記
export const clearRequest = {
  clearArray: []
}
// 跳轉不需要取消請求的接口
const stableUrls = ["/add/pic", "/getBaseSiteConfig"]

// create an axios instance
const service = axios.create({
  baseURL: baseApi,
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 3600000 // request timeout
})

// request攔截器 request interceptor
service.interceptors.request.use(
  config => {
    if (!stableUrls.includes(config.url)) {
      config.cancelToken = new axios.CancelToken(function (cancel) {
        clearRequest.clearArray.push(cancel)
      })
    }
    if (store.getters.token) {
      config.headers['Token'] = store.getters.token
    }
    config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json;charset=UTF-8'
    if (config.data && config.headers['Content-Type'].includes('application/x-www-form-urlencoded')) {
      config.data = qs.stringify(config.data)
    }
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)
// respone攔截器
service.interceptors.response.use(
  response => {
    if (response.status && response.status !== 200) {
      // 登錄超時,重新登錄
      if (response.status === 401) {
        message.error(i18n.t('message.timeOut'));
        store.dispatch("logout")
      }
      return Promise.reject('error')
    } else {
      const res = response.data
      //下載zip文件
      if (response.config.url && response.config.url.endsWith(".zip")) {
        return Promise.resolve(res);
      }
      // if(res.type && res.type == "application/zip") {
      //   return Promise.resolve(res);
      // }
      if (res.code === 1) {
        return Promise.resolve(res)
      } else {
        message.error(res.msg || res.message);
        return Promise.reject(res.message || '操作失敗')
      }
    }
  },
  error => {
    // message.error('請求失敗');
    console.log('err==' + error)
    return Promise.reject(error)
  }
)

export default service